var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4404 16.5878C19.1826 17.369 19.1826 18.6345 18.4404 19.4157C18.0723 19.8063 17.5855 20 17.0987 20C16.6118 20 16.1262 19.8047 15.7557 19.4141L9.49926 12.8318L3.2434 19.4125C2.87234 19.8063 2.38609 20 1.89985 20C1.41361 20 0.927959 19.8063 0.556597 19.4125C-0.185532 18.6314 -0.185532 17.3658 0.556597 16.5846L6.81423 9.99766L0.556597 3.4138C-0.185532 2.63261 -0.185532 1.36708 0.556597 0.585892C1.29873 -0.195297 2.50098 -0.195297 3.24311 0.585892L9.49926 7.176L15.7569 0.589017C16.499 -0.192172 17.7013 -0.192172 18.4434 0.589017C19.1855 1.37021 19.1855 2.63573 18.4434 3.41692L12.1858 10.0039L18.4404 16.5878Z",
    fill: "#19274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.43aae170e0cf24a7cab8b320d80c2bb3.svg";
export { ForwardRef as ReactComponent };